import React from "react";
import { Col, Row, Form, Input, Checkbox } from "antd";

import Popup from "../../../components/Popup";

export default function StockPopup({
  cancelHandler,
  saveHandler,
  data = {}
}) {
  const [form] = Form.useForm();

  function saveStock() {
    form
      .validateFields()
      .then((values) => {
        values = { ...values, store_is_active: values.store_active ? 1 : 0 };
        saveHandler(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  }

  return (
    <Popup
      width="55%"
      visible
      title='Edit Stock Details'
      cancelHandler={cancelHandler}
      saveHandler={saveStock}
    >
      <Form
        requiredMark={false}
        form={form}
        layout="vertical"
        name="stock"
        initialValues={data}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              name="variant_stock"
              key="variant_stock"
              label="Quantity"
              rules={[
                {
                  validator: (_, value) => {
                    if (value >= 0) {
                      if (parseInt(value).toString().length < value.length) {
                        return Promise.reject(
                          new Error("Only Integers are allowed !")
                        );
                      }
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Quantity should be a number !")
                    );
                  },
                },
              ]}
            >
              <Input maxLength={8} placeholder="Ex. 2000" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="cost_price"
              key="cost_price"
              label="Cost Price"
              rules={[
                {
                  validator: (_, value) => {
                    if (value > 0) {
                      if (parseFloat(value).toFixed(2).length < value.length) {
                        return Promise.reject(
                          new Error("Numbers upto 2 decimal places")
                        );
                      }
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Cost Price should be a number !")
                    );
                  },
                },
              ]}
            >
              <Input prefix="₹ " placeholder="Ex. ₹ 89.99" />
            </Form.Item>
            <div style={{ position: "absolute", right: 10, top: -5 }}>
              <Form.Item
                name="store_active"
                key="store_active"
                valuePropName="checked"
                initialValue={data.store_is_active === 0 ? false : true}
                style={{ marginBottom: 2 }}
              >
                <Checkbox>Active</Checkbox>
              </Form.Item>
            </div>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="mrp"
              key="mrp"
              label="Max Retail Price"
              rules={[
                {
                  validator: (_, value) => {
                    if (value > 0) {
                      if (parseFloat(value).toFixed(2).length < value.length) {
                        return Promise.reject(
                          new Error("Numbers upto 2 decimal places")
                        );
                      }
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("MRP should be a number !")
                    );
                  },
                },
              ]}
            >
              <Input prefix="₹ " placeholder="Ex. ₹ 99.99" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="price"
              key="price"
              label="Sell Price"
              rules={[
                {
                  validator: (_, value) => {
                    if (value > 0) {
                      if (parseFloat(value).toFixed(2).length < value.length) {
                        return Promise.reject(
                          new Error("Numbers upto 2 decimal places")
                        );
                      }
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Sell Price should be a number !")
                    );
                  },
                },
              ]}
            >
              <Input prefix="₹ " placeholder="Ex. ₹ 79.99" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Popup>
  );
}
